import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import { renderContactCard } from './utils'

const TrustClaimsManagerWidget = (props) => {
	const { data } = props
	const { process } = data
	const { i18n } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			title={i18n`Trust Claims Manager`}
			collapsedLabel={process?.trustClaimsManager?.name}
			icon='user'
			expanded={false}
			expandable={!!process?.trustClaimsManager}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{renderContactCard(process?.trustClaimsManager || {}, i18n)}
		</ExpandableWidget>
	)
}

export default TrustClaimsManagerWidget
